'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _reactRedux = require('react-redux');
var _fieldInfo = require('../../selectors/field-info');
var _addressLookup = require('../../actions/address-lookup');
var _input = require('../input');
var _input2 = _interopRequireDefault(_input);
var _controlFields = require('../../hocs/control-fields');
var _controlFields2 = _interopRequireDefault(_controlFields);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Lookup = function (_Component) {
  _inherits(Lookup, _Component);
  function Lookup() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, Lookup);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Lookup.__proto__ || Object.getPrototypeOf(Lookup)).call.apply(_ref, [this].concat(args))), _this), _this.lookupAddress = function () {
      var _this$props = _this.props,
        lookupAddress = _this$props.lookupAddress,
        values = _this$props.values,
        formId = _this$props.formId,
        fieldNames = _this$props.fieldNames,
        validate = _this$props.validate,
        name = _this$props.name,
        postcodeError = _this$props.postcodeError;
      if (!postcodeError) {
        lookupAddress(formId, {
          postcode: values[fieldNames.Postcode],
          buildingNameNumber: values[fieldNames.BuildingNameNumber]
        }, validate, name);
      }
    }, _this.renderPostcodeLookup = function (props) {
      return _react2.default.createElement(_input.InputWithButton, Object.assign({}, props, {
        prominence: 'primary',
        text: 'Find address',
        handleSubmit: _this.lookupAddress,
        format: ['alpha-int', 'uppercase', 'no-spaces'],
        maxLength: '8'
      }));
    }, _this.setManualView = function () {
      _this.props.setView(_this.props.formId, _this.props.name, 'manual');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(Lookup, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', null, _react2.default.createElement('fieldset', {
        style: {
          border: 'unset',
          padding: 'unset',
          margin: 'unset'
        }
      }, _react2.default.createElement('legend', {
        style: {
          fontWeight: 700
        }
      }, this.props.label), _react2.default.createElement(_input2.default, {
        name: this.props.fieldNames.BuildingNameNumber,
        label: 'Building name/number'
      }), _react2.default.createElement(_input2.default, {
        name: this.props.fieldNames.Postcode,
        label: 'Postcode',
        input: this.renderPostcodeLookup,
        extra: _react2.default.createElement('a', {
          onClick: this.setManualView
        }, 'Enter address manually')
      })));
    }
  }]);
  return Lookup;
}(_react.Component);
Lookup.propTypes = {
  // props
  name: _propTypes.string.isRequired,
  fieldNames: _propTypes.object.isRequired,
  // controlFields
  validate: _propTypes.func.isRequired,
  formId: _propTypes.string.isRequired,
  values: _propTypes.object.isRequired,
  // dtp
  lookupAddress: _propTypes.func.isRequired,
  // stp
  postcodeError: _propTypes.bool.isRequired,
  setView: _propTypes.func.isRequired
};
exports.default = (0, _controlFields2.default)((0, _reactRedux.connect)(function (state, ownProps) {
  return {
    postcodeError: !!(0, _fieldInfo.getError)(state, ownProps.formId, ownProps.fieldNames.Postcode)
  };
}, {
  lookupAddress: _addressLookup.lookupAddress,
  setView: _addressLookup.setView
})(Lookup));